export default "__VITE_ASSET__mXCCxD2y__"